import { Waypoint } from '@omniafishing/core';
import { fitBounds } from '../../../lib/fit_bounds';
import { getEnv } from '../../../env';

export const waypointImgURL = (waypoint: Waypoint) => {
  if (!waypoint) {
    return null;
  }

  const { waterbody, waypoint_type, lat, lng } = waypoint;

  const imgSize = { width: 1200, height: 627 };

  const zoomLevel = waterbody?.bbox
    ? fitBounds([waterbody.bbox[0], waterbody.bbox[2]], {
        width: imgSize.width,
        height: imgSize.height,
      }).zoom
    : 12;

  const markerPath = encodeURIComponent(
    `https://omniafishing-dotcom.s3.us-east-2.amazonaws.com/map/${waypoint_type}_icon.png`
  );

  const marker = `url-${markerPath}(${lng},${lat})/`;

  const mapboxImgURL = `https://api.mapbox.com/styles/v1/omniafishing/cl8nijurz000u14o94ojffmkg/static/${marker}${lng},${lat},${zoomLevel},0.00,0.00/${
    imgSize.width
  }x${imgSize.height}@2x?access_token=${getEnv().MAPBOX_ACCESS_TOKEN}`;

  return mapboxImgURL;
};
